@if (isLoading()) {
    <div class="streak-card streak-card--loading">
        <mat-spinner diameter="32" />
    </div>
} @else if(streak()) {
    <div class="streak-card">
        <div class="streak-header">
            <span class="streak-title">
              @for (item of animatedChars(); track item.index) {
                <span 
                  class="flame-char"
                  [style.animation-delay]="(item.index * 0.05) + 's'"
                >{{ item.char }}</span>
              }
            </span>
        </div>
        <div class="streak-container">
            <div class="current-box" [class.streak-inactive]="streak().currentStreak < 1">
                <div class="current-count">{{ streak().currentStreak }}</div>
                <div class="current-unit">{{ streak().currentStreak > 1 ? 'WKS' : 'WK' }}</div>
            </div>
            <div class="msg-box">
                <div class="streak-message">{{ streak().motivationalMessage }} 🔥</div>
                <div class="best-message">Best: {{ streak().bestStreak }} weeks</div>
            </div>
        </div>
    </div>
} @else {
    <div class="streak-card">
        Streak data is not available at this time. Check back soon!
    </div>
}
